module.exports = __webpack_public_path__ + "ve.svg?a0d8230b9063dfa5323727f4a3b554c3";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/ve.svg
// module id = 1220
// module chunks = 27